import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export const MainHeroBanner = () => {
  const navigate = useNavigate();
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <div className="relative w-full overflow-hidden rounded-3xl mb-12 group">
      {/* Background with Action Image and Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1574629810360-7efbbe195018?q=80&w=1600" 
          alt="Stadium" 
          className="w-full h-full object-cover opacity-70 group-hover:scale-105 transition-transform duration-1000"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/40 to-transparent"></div>
      </div>

      {/* Gigantic Background Text (Outline Effect) */}
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-20 pointer-events-none select-none">
        <h2 className="text-[12rem] md:text-[20rem] font-black uppercase tracking-tighter text-white" style={{ WebkitTextStroke: '2px white', color: 'transparent' }}>
          SPORTS
        </h2>
      </div>

      {/* Main Content Area */}
      <div className="relative z-10 p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-8">
        
        {/* Brand Presence */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4">
          <div className="flex items-center gap-4">
            <div className="p-1 bg-[#39FF14] rounded-full shadow-[0_0_15px_#39FF14] neon-flicker">
              <img src="/fu-logo.png" alt="Logo" className="w-16 h-16 rounded-full object-contain bg-black p-1" />
            </div>
            <div>
              <h1 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter leading-none italic">
                INVERSIONES<span className="text-[#39FF14] neon-flicker inline-block">FU</span>
              </h1>
              <div className="h-1 w-20 bg-[#39FF14] mt-2 neon-flicker"></div>
            </div>
          </div>
          
          <div className="space-y-1">
            <p className="text-[#39FF14] text-xl md:text-2xl font-bold uppercase tracking-widest flex items-center gap-2">
              <span className="w-4 h-0.5 bg-[#39FF14]"></span>
              TU ALTERNATIVA SPORTS
              <span className="w-4 h-0.5 bg-[#39FF14]"></span>
            </p>
            <p className="text-gray-400 text-sm md:text-base font-medium max-w-md">
              Las mejores camisetas y gorras deportivas de Venezuela. Calidad profesional garantizada.
            </p>
          </div>
        </div>

        {/* Dynamic Cart Summary/Action */}
        <button
          onClick={() => { navigate('/catalogo', { replace: true }); navigate('/cart'); }}
          className="group/btn relative flex flex-col items-center justify-center p-6 bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl hover:border-[#39FF14] transition-all duration-500 shadow-2xl overflow-hidden"
        >
          <div className="absolute inset-0 bg-[#39FF14]/5 opacity-0 group-hover/btn:opacity-100 transition-opacity"></div>
          <div className="relative z-10 flex items-center justify-center mb-2">
            <svg className="w-10 h-10 text-white group-hover/btn:text-[#39FF14] transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#39FF14] text-black text-xs font-black w-6 h-6 rounded-full flex items-center justify-center shadow-[0_0_15px_#39FF14]">
                {cartCount}
              </span>
            )}
          </div>
          <span className="text-white text-xs font-black uppercase tracking-widest group-hover/btn:text-[#39FF14] transition-colors">Carrito</span>
          <div className="mt-2 text-[10px] text-gray-500 font-bold tracking-tighter">LISTO PARA ENVIAR</div>
        </button>
      </div>
    </div>
  );
};
